"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _reflux = _interopRequireDefault(require("reflux"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_sanofi/cssConstants.js"));

var _ThemeActions = _interopRequireDefault(require("./ThemeActions"));

var _ColorHelper = require("../../../helpers/ColorHelper");

var _CordovaHelper = require("../../../helpers/CordovaHelper");

var _ObjectHelper = require("../../../helpers/ObjectHelper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var ThemeStore = /*#__PURE__*/function (_Reflux$Store) {
  (0, _inherits2["default"])(ThemeStore, _Reflux$Store);

  var _super = _createSuper(ThemeStore);

  function ThemeStore() {
    var _this;

    (0, _classCallCheck2["default"])(this, ThemeStore);
    _this = _super.call(this);
    _this.listenables = _ThemeActions["default"];
    _this.state = {
      currentTheme: 'default',
      button: {
        "default": {
          buttonBorder: _cssConstants["default"].colors.buttonBorder,
          buttonBorderSecondary: _cssConstants["default"].colors.buttonBorderSecondary,
          buttonCaption: _cssConstants["default"].colors.buttonCaption,
          buttonCaptionSecondary: _cssConstants["default"].colors.buttonCaptionSecondary,
          buttonBackground: _cssConstants["default"].colors.buttonBackground,
          buttonBorderLight: _cssConstants["default"].colors.buttonBorderLight,
          buttonCaptionLight: _cssConstants["default"].colors.buttonCaptionLight,
          buttonBackgroundLight: _cssConstants["default"].colors.buttonBackgroundLight,
          buttonBorderDark: _cssConstants["default"].colors.buttonBorderDark,
          buttonCaptionDark: _cssConstants["default"].colors.buttonCaptionDark,
          buttonBackgroundDark: _cssConstants["default"].colors.buttonBackgroundDark,
          buttonCaptionBlue: _cssConstants["default"].colors.buttonCaptionBlue,
          buttonBackgroundBlue: _cssConstants["default"].colors.buttonBackgroundBlue,
          buttonBorderBlue: _cssConstants["default"].colors.buttonBorderBlue
        }
      },
      navbar: {
        "default": {
          navbarBackground: _cssConstants["default"].colors.navbarBackground,
          navbarText: _cssConstants["default"].colors.navbarText,
          navbarItemColor: _cssConstants["default"].colors.navbarItemColor
        }
      },
      quiz: {
        "default": {
          correct: _cssConstants["default"].colors.correct,
          wrong: _cssConstants["default"].colors.wrong,
          opponentAnswer: _cssConstants["default"].colors.opponentAnswer,
          quizMainColor: _cssConstants["default"].colors.quizMainColor,
          quizBorderColor: _cssConstants["default"].colors.quizBorderColor,
          quizSecondColor: _cssConstants["default"].colors.quizSecondColor,
          quizThirdColor: _cssConstants["default"].colors.quizThirdColor,
          quizBackground: _cssConstants["default"].colors.quizBackground,
          quizText: _cssConstants["default"].colors.quizText,
          quizTimer: _cssConstants["default"].colors.quizTimer,
          homeBackground: _cssConstants["default"].colors.homeBackground,
          homeTextColor: _cssConstants["default"].colors.homeTextColor,
          highScoreUserColor: _cssConstants["default"].colors.highScoreUserColor,
          highScoreOpponentColor: _cssConstants["default"].colors.highScoreOpponentColor,
          mainTextColor: _cssConstants["default"].colors.mainTextColor
        }
      },
      menu: {
        "default": {
          menuBackground: _cssConstants["default"].colors.menuBackground
        }
      },
      lightText: _cssConstants["default"].colors.lightText,
      textfieldCaption: _cssConstants["default"].colors.textfieldCaption,
      tab: _cssConstants["default"].colors.tab,
      tabBackground: _cssConstants["default"].colors.tabBackground,
      tableDivider: _cssConstants["default"].colors.tableDivider,
      questionHeader: _cssConstants["default"].colors.questionHeader,
      questionHeaderText: _cssConstants["default"].colors.questionHeaderText,
      questionHeaderPointsText: _cssConstants["default"].colors.questionHeaderPointsText,
      questionTimer: _cssConstants["default"].colors.questionTimer,
      questionText: _cssConstants["default"].colors.questionText,
      answerDivider: _cssConstants["default"].colors.answerDivider,
      dialogText: _cssConstants["default"].colors.dialogText,
      dialogDivider: _cssConstants["default"].colors.dialogDivider,
      dialogBackground: _cssConstants["default"].colors.dialogBackground,
      roundFeedbackHeaderText: _cssConstants["default"].colors.roundFeedbackHeaderText,
      roundFeedbackDetailsText: _cssConstants["default"].colors.roundFeedbackDetailsText,
      correct: _cssConstants["default"].colors.correct,
      correctButNotChosen: _cssConstants["default"].colors.correctButNotChosen,
      wrong: _cssConstants["default"].colors.wrong
    };
    return _this;
  }

  (0, _createClass2["default"])(ThemeStore, [{
    key: "resetTheme",
    value: function () {
      var _resetTheme = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  currentTheme: 'default',
                  button: {
                    "default": {
                      buttonBorder: _cssConstants["default"].colors.buttonBorder,
                      buttonBorderSecondary: _cssConstants["default"].colors.buttonBorderSecondary,
                      buttonCaption: _cssConstants["default"].colors.buttonCaption,
                      buttonCaptionSecondary: _cssConstants["default"].colors.buttonCaptionSecondary,
                      buttonBackground: _cssConstants["default"].colors.buttonBackground,
                      buttonBorderLight: _cssConstants["default"].colors.buttonBorderLight,
                      buttonCaptionLight: _cssConstants["default"].colors.buttonCaptionLight,
                      buttonBackgroundLight: _cssConstants["default"].colors.buttonBackgroundLight,
                      buttonBorderDark: _cssConstants["default"].colors.buttonBorderDark,
                      buttonCaptionDark: _cssConstants["default"].colors.buttonCaptionDark,
                      buttonBackgroundDark: _cssConstants["default"].colors.buttonBackgroundDark,
                      buttonCaptionBlue: _cssConstants["default"].colors.buttonCaptionBlue,
                      buttonBackgroundBlue: _cssConstants["default"].colors.buttonBackgroundBlue,
                      buttonBorderBlue: _cssConstants["default"].colors.buttonBorderBlue
                    }
                  },
                  navbar: {
                    "default": {
                      navbarBackground: _cssConstants["default"].colors.navbarBackground,
                      navbarText: _cssConstants["default"].colors.navbarText
                    }
                  },
                  quiz: {
                    "default": {
                      correct: _cssConstants["default"].colors.correct,
                      wrong: _cssConstants["default"].colors.wrong,
                      opponentAnswer: _cssConstants["default"].colors.opponentAnswer,
                      quizMainColor: _cssConstants["default"].colors.quizMainColor,
                      quizBorderColor: _cssConstants["default"].colors.quizBorderColor,
                      quizSecondColor: _cssConstants["default"].colors.quizSecondColor,
                      quizThirdColor: _cssConstants["default"].colors.quizThirdColor,
                      quizBackground: _cssConstants["default"].colors.quizBackground,
                      quizText: _cssConstants["default"].colors.quizText,
                      quizTimer: _cssConstants["default"].colors.quizTimer,
                      homeBackground: _cssConstants["default"].colors.homeBackground,
                      homeTextColor: _cssConstants["default"].colors.homeTextColor,
                      highScoreUserColor: _cssConstants["default"].colors.highScoreUserColor,
                      highScoreOpponentColor: _cssConstants["default"].colors.highScoreOpponentColor,
                      mainTextColor: _cssConstants["default"].colors.mainTextColor
                    }
                  },
                  menu: {
                    "default": {
                      menuBackground: _cssConstants["default"].colors.menuBackground
                    }
                  },
                  lightText: _cssConstants["default"].colors.lightText,
                  textfieldCaption: _cssConstants["default"].colors.textfieldCaption,
                  tab: _cssConstants["default"].colors.tab,
                  tabBackground: _cssConstants["default"].colors.tabBackground,
                  tableDivider: _cssConstants["default"].colors.tableDivider,
                  questionHeader: _cssConstants["default"].colors.questionHeader,
                  questionHeaderText: _cssConstants["default"].colors.questionHeaderText,
                  questionHeaderPointsText: _cssConstants["default"].colors.questionHeaderPointsText,
                  questionTimer: _cssConstants["default"].colors.questionTimer,
                  questionText: _cssConstants["default"].colors.questionText,
                  answerDivider: _cssConstants["default"].colors.answerDivider,
                  dialogText: _cssConstants["default"].colors.dialogText,
                  dialogDivider: _cssConstants["default"].colors.dialogDivider,
                  dialogBackground: _cssConstants["default"].colors.dialogBackground,
                  roundFeedbackHeaderText: _cssConstants["default"].colors.roundFeedbackHeaderText,
                  roundFeedbackDetailsText: _cssConstants["default"].colors.roundFeedbackDetailsText,
                  correct: _cssConstants["default"].colors.correct,
                  correctButNotChosen: _cssConstants["default"].colors.correctButNotChosen,
                  wrong: _cssConstants["default"].colors.wrong
                });
                return _context.abrupt("return", _promise["default"].resolve());

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function resetTheme() {
        return _resetTheme.apply(this, arguments);
      }

      return resetTheme;
    }()
  }, {
    key: "onInitThemeStore",
    value: function onInitThemeStore() {}
  }, {
    key: "onAddTheme",
    value: function onAddTheme(theme) {
      var _this2 = this;

      var fillUpOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var excludeNavbar = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      console.log({
        newTheme: theme,
        previous: this.state,
        fillUpOnly: fillUpOnly
      });
      this.state.currentTheme = theme.currentTheme; // let updateStatusBarTextColor = false

      if ('button' in theme) {
        var theme1 = fillUpOnly ? theme.button : this.state.button;
        var theme2 = fillUpOnly ? this.state.button : theme.button;
        this.state.button = (0, _assign["default"])({}, theme1, theme2);
      }

      if (!excludeNavbar && 'navbar' in theme) {
        var _theme = fillUpOnly ? theme.navbar : this.state.navbar;

        var _theme2 = fillUpOnly ? this.state.navbar : theme.navbar;

        this.state.navbar = (0, _assign["default"])({}, _theme, _theme2); // updateStatusBarTextColor = true
      }

      if ('quiz' in theme) {
        var _theme3 = fillUpOnly ? theme.quiz : this.state.quiz;

        var _theme4 = fillUpOnly ? this.state.quiz : theme.quiz;

        this.state.quiz = (0, _assign["default"])({}, _theme3, _theme4);
      }

      (0, _keys["default"])(theme).forEach(function (key) {
        if (['button', 'navbar', 'quiz'].indexOf(key) >= 0) {
          return;
        }

        if (!fillUpOnly || !_this2.state[key]) {
          _this2.state[key] = theme[key];
        }
      });
      this.trigger(this.state);
    }
  }]);
  return ThemeStore;
}(_reflux["default"].Store);

var themeStore = _reflux["default"].initStore(ThemeStore);

var _default = themeStore;
exports["default"] = _default;